var map = {
	"./pureflo": "Za8W",
	"./pureflo.js": "Za8W",
	"./water": "n0nC",
	"./water-regional": "PyJf",
	"./water-regional.js": "PyJf",
	"./water.js": "n0nC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fB5b";